import { render, staticRenderFns } from "./bursaries.vue?vue&type=template&id=37d87acc&"
import script from "./bursaries.vue?vue&type=script&lang=js&"
export * from "./bursaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports